import { Component, ChangeDetectionStrategy, Input, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

type onChangeCallback = (value: unknown) => unknown;
type onTouchCallback = (value: unknown) => unknown;

@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    styleUrls: ['./text-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, TranslatePipe],
})
export class TextAreaComponent implements ControlValueAccessor, OnInit {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly controlContainer = inject(ControlContainer);

    @Input({ required: true }) controlName!: string;
    @Input({ required: true }) label!: string;
    @Input() rows = 10;
    @Input() cols = 60;
    @Input() required = false;

    protected disabled?: boolean;
    protected inputValue: unknown = '';

    control!: FormControl;

    ngOnInit(): void {
        this.control = <FormControl>this.controlContainer.control!.get(this.controlName);
    }

    get value(): unknown {
        return this.inputValue;
    }

    set value(value: unknown) {
        if (value !== this.inputValue) {
            this.inputValue = value;
            this.onChange(value);
            this.onTouch(value);
        }
    }

    writeValue(value: unknown): void {
        if (value !== this.inputValue) {
            this.inputValue = value;
            this.changeDetectorRef.detectChanges();
        }
    }

    registerOnChange(fn: onChangeCallback): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: onTouchCallback): void {
        this.onTouch = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onChange: onChangeCallback = (): void => {
        return;
    };

    onTouch: onTouchCallback = (): void => {
        return;
    };

    onClick(): void {
        this.onChange(this.inputValue);
    }
}
